<template>
    <div class="defective-box">
        <el-tabs v-model="tabName" @tab-click="handleTab">
            <el-tab-pane label="次品组" name="group"></el-tab-pane>
            <el-tab-pane label="次品员" name="member"></el-tab-pane>
        </el-tabs>

        <div v-if="tabName == 'group'">
            <group></group>
        </div>
        <div v-if="tabName == 'member'">
            <member></member>
        </div>
    </div>
</template>

<script>
import Group from "./group";
import Member from "./member";
export default {
    components: {
        Group,
        Member
    },
    data() {
        return {
            loading: false,
            tabName: "group"
        };
    },
    methods: {
        handleTab(tab) {
            this.tabName = tab.name;
        }
    }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/defectivegroup/index.vue